interface WalletIconsProps {
  coin: string;
  className?: string;
}

const WalletIcons = ({ coin, className }: WalletIconsProps) => {
  return (
    (<img
      src={`https://static.delta.exchange/common/icons/crypto-coins/${coin?.toLowerCase()}.png`}
      className={className}
      alt="asset-icon"
      data-palette="WalletIcons" />)
  );
};

WalletIcons.displayName = 'WalletIcons';

export { WalletIcons };
